import React, { useState } from "react";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from "@stripe/react-stripe-js";

import { getIcon } from "../../../../helpers/icons";
import CheckoutForm from "./CheckoutForm";

import style from "../style.module.css";
import { get } from "lodash";

export default function PaymentForm(props) {
    const {
        paymentIntentDetails,
        couponId,
        planId,
        userId,
        planType,
        personalDetails,
        nextStep,
        total = 0,
        color = "buttonDefault",
        from="register",
        setStep = null,
        autoRenewal = true
    } = props;

    const [paymentError, setPaymentError] = useState(false);
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
    const clientSecret = paymentIntentDetails.clientSecret;
    const appearance = {
        theme: 'light',
        labels: 'floating'
    };
    
    return (
        <Elements stripe={stripePromise} options={{ appearance, clientSecret }}>
            <CheckoutForm
                couponId={couponId}
                planId={planId}
                userId={userId}
                planType={planType}
                personalDetails={personalDetails}
                setPaymentError={setPaymentError}
                paymentError={paymentError}
                paymentIntentDetails={paymentIntentDetails}
                nextStep={nextStep}
                total={total}
                color={color}
                from={from}
                setStep={setStep}
                autoRenewal={autoRenewal}
            />
            {
                paymentError && (
                    <div className={`${style.toast} ${style.red} ${style.paymentError}`}>
                        <i className={getIcon("Xmark")}></i>
                        {get(paymentError,'message', '')}
                    </div>
                )
            }
        </Elements>
    )
}